import { render, staticRenderFns } from "./industry_index.vue?vue&type=template&id=7bb46185&scoped=true"
import script from "./industry_index.vue?vue&type=script&lang=js"
export * from "./industry_index.vue?vue&type=script&lang=js"
import style0 from "./industry_index.vue?vue&type=style&index=0&id=7bb46185&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb46185",
  null
  
)

export default component.exports